import { useMemo } from "react";

import noThumbnail from "../../assets/images/no-thumbnail.png";
import useAccount from "../../hooks/useAccount";
import type { ProjectData } from "../../hooks/useProject";
import { formatDate } from "../../utils/helpers";
import { UserName } from "../UserName/UserName";

import style from "./ProjectMetadata.module.css";
export const ProjectMetadata = ({ projectData }: { projectData: ProjectData }) => {
  const { data: accountData } = useAccount();

  const userName = useMemo(() => {
    const user = projectData.users?.find(
      (user) => user.userId === projectData.latestRevision.uploadedByUserId
    );
    if (user && user.userId === accountData?.id) {
      return user.name ? `${user.name} (You)` : "You";
    }
    return user?.name;
  }, [projectData, accountData]);

  const platformMap = useMemo(() => {
    switch (projectData.latestRevision.uploadedByPlatform) {
      case "ios":
        return "iPad";
      case "macos":
        return "Mac";
      case "visionos":
        return "Vision Pro";
      case "windows":
        return "Windows";
    }
  }, [projectData]);

  return (
    <div className={style.container}>
      <div className={style.title}>Information</div>

      <div className={style.thumbnail}>
        <img
          src={
            projectData?.latestRevision.thumbnailDownloads?.light?.url
              ? projectData?.latestRevision.thumbnailDownloads?.light?.url
              : noThumbnail
          }
          alt="Thumbnail"
        />
      </div>

      <div className={style.row}>
        <div className={style.rowTitle}>Version</div>
        <div className={style.rowValue}>#{projectData.latestRevision.revisionId}</div>
      </div>

      <div className={style.row}>
        <div className={style.rowTitle}>Copy of</div>
        <div className={style.rowValue}>{projectData.latestRevision.copyOfRevisionId ?? "-"}</div>
      </div>

      <div className={style.row}>
        <div className={style.rowTitle}>Edited by</div>
        <div className={style.rowValue}>
          <UserName name={userName ?? "-"} />
        </div>
      </div>

      <div className={style.row}>
        <div className={style.rowTitle}>Version created</div>
        <div className={style.rowValue}>
          {projectData.latestRevision.createdAt
            ? formatDate(projectData.latestRevision.createdAt)
            : "-"}
        </div>
      </div>

      <div className={style.row}>
        <div className={style.rowTitle}>Synced</div>
        <div className={style.rowValue}>
          {projectData.latestRevision.lastModifiedAt
            ? formatDate(projectData.latestRevision.lastModifiedAt)
            : "-"}
        </div>
      </div>

      <div className={style.row}>
        <div className={style.rowTitle}>Client</div>
        <div className={style.rowValue}>{platformMap}</div>
      </div>
    </div>
  );
};
